import React, { Component } from 'react';

interface Props {
  
}

interface State {
  
}

class Activities extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      
    };
  }

  
  render() {
    return (
      <div>
        <h1>Hello from Co-Curricular Activities</h1>
      </div>
    );
  }
}

export default Activities;